import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import {Button} from '@gisatcz/ptr-atoms';

import eo4drr from '../../assets/img/logo-eo4drr-white.png';
import esa from '../../assets/img/logo-esa.png';
import './style.scss';

class IntroOverlay extends React.PureComponent {
	static defaultProps = {
		open: true,
	};

	static propTypes = {
		open: PropTypes.bool,
	};

	changeState(changeSource) {
		let action = 'Close intro via x';
		if (changeSource === 'title') {
			action = this.props.open ? 'Close intro via title' : 'Open intro';
		}

		ReactGA.event({
			category: 'Basic interaction',
			action,
			label: 'intro',
		});

		this.props.changeState(!this.props.open);
	}

	render() {
		const classes = classnames('eo4sdDrrInsarVietnam20-intro-overlay', {
			minimised: !this.props.open,
		});

		return (
			<div className={classes}>
				<Button
					className="eo4sdDrrInsarVietnam20-overlay-close"
					icon="times"
					invisible
					inverted
					onClick={this.changeState.bind(this, 'button')}
				/>
				<div
					id="eo4sdDrrInsarVietnam20-header"
					onClick={this.changeState.bind(this, 'title')}
				>
					<span>
						EO4SD-DRR Service Demo: Detailed terrain deformation analysis in
						urban areas (WB-CRP-02)
					</span>
					Assessment of land subsidence in Vinh Long, Vietnam
				</div>
				<div className="eo4sdDrrInsarVietnam20-intro-content">
					<div>
						<p>
							The Mekong Delta is subjected to hazards events including
							typhoons, floods, and drought, which are expected to become more
							frequent and intense with climate change. The large part of the
							Delta area is flooded on annual basis to a depth of 1 m to 3 m.
							The situation is further exacerbated by sea-level rise and land
							subsidence, which is in part linked to overextraction of
							groundwater. As a consequence of land subsidence, many rural and
							urban in-land areas are becoming more vulnerable to flooding
							impacts.
						</p>
						<p>
							The EO4SD-DRR service delivers showcase products demonstrating
							utility of Earth Observation technology for mapping land
							subsidence and facilitation of impacts assessment at city-level
							scale. Advanced{' '}
							<b>multi-temporal interferometric technique (MT InSAR)</b> allows
							detection of surface motions using satellite-born measurements
							with up to millimetric accuracy and reveals spatial patterns of
							land subsidence in synoptic view.
						</p>
						<p>Geospatial information derived by MT InSAR provides means to:</p>
						<ol>
							<li>
								identify assets exposed to land subsidence hazard: buildings,
								urban and land blocks, roads and other infrastructure elements;
								and to{' '}
							</li>
							<li>
								analyse them in relation with potential driving factors and
								vulnerability to evaluate impacts and related risks.{' '}
							</li>
						</ol>
						<p>
							The <b>app’s Land subsidence panel</b> provides velocity map which
							shows subsidence patterns and magnitude expressed as average
							annual displacement rate in vertical direction. Measurement points
							were detected by Persistent Scatterers Interferometry method (PSI)
							using stacks of images from ascending and descending orbits of
							Sentinel-1 satellites. Images were acquired between 2014 and 2020
							and analysis is relevant for this period.
						</p>
						<p>
							Intensity of exposure to subsidence is depicted by aps and
							statistics accessible in the <b>Exposure panel</b>. Exposure is
							provided for two types of assets: urban land use blocks and road
							infrastructure. Land use changes related to built-ups and
							construction sites can be additionally displayed to assess
							relation between detected subsidence and recent urban development.
							Hence potential near- to mid-term subsidence hot-spots can be
							identified.
						</p>
						<p>
							Understanding existing and evolving pattern of hazard and its
							impact on exposed or planned assets is crucial for design of{' '}
							<b>mitigation scenarios and protective measures</b>,
							implementation of{' '}
							<b>
								proactive monitoring tools and ex-post evaluation of mitigation
								effectivity
							</b>
							.
						</p>
						<p>
							The online service demonstrator targets users in the World Bank
							(WB) and Vietnamese institutions:
						</p>
						<ul>
							<li>
								WB’s <b>City Resilience Programme (CRP)</b> with aim to build
								awareness about the characteristics and specificities of the
								terrain motion product considering need of Earth Observation
								supporting City Scan platform on annual basis
							</li>
							<li>
								<b>
									Vinh Long City Urban Development and Enhanced Climate
									Resilience Project in Vinh Long Province
								</b>{' '}
								(P171700) to show potential of subsidence mapping and monitoring
								to facilitate future urban planning related to relocations and
								resettlements.
							</li>
						</ul>
					</div>
				</div>
				<div className="eo4sdDrrInsarVietnam20-intro-footer">
					<div className="eo4sdDrrInsarVietnam20-intro-logos">
						<a
							href="https://www.eo4sd-drr.eu/"
							target="_blank"
							rel="noreferrer noopener"
						>
							<img alt="EO4D logo" className="eo4drr" src={eo4drr} />
						</a>
						<a
							href="http://www.esa.int/"
							target="_blank"
							rel="noreferrer noopener"
						>
							<img alt="esa logo" className="esa" src={esa} />
						</a>
					</div>
					<div className="eo4sdDrrInsarVietnam20-intro-copyrights">
						© {`${new Date().getFullYear()}`}{' '}
						<a
							href="http://gisat.cz/content/en"
							target="_blank"
							rel="noreferrer noopener"
						>
							Gisat
						</a>
					</div>
				</div>
			</div>
		);
	}
}

export default IntroOverlay;
